import { useEffect, useRef } from "react";

// One-shot scroll to the element with the given id, fired once when `key` changes from null to a value.
// Subsequent re-renders never re-scroll; the user is in control after the initial position.
export function useScrollToNow(elementId: string | null, key: string | null) {
  const fired = useRef<string | null>(null);
  useEffect(() => {
    if (!elementId || !key) return;
    if (fired.current === key) return;
    fired.current = key;
    const raf = requestAnimationFrame(() => {
      const el = document.getElementById(elementId);
      if (el) {
        el.scrollIntoView({ block: "center", behavior: "instant" as ScrollBehavior });
      }
    });
    return () => cancelAnimationFrame(raf);
  }, [elementId, key]);
}
